// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * cm-coding: Global administrators review and run migrations from the same
 * visual frame as other system operations. This route supplies the shared
 * background and content width, while MigrationsManager supplies the heading
 * and migration controls; a second heading here would make one operation look
 * like two unrelated tools.
 */
import { MigrationsManager } from '../components/MigrationsManager';

export default function MigrationsPage() {
  return (
    <div className="min-h-full bg-slate-50 text-slate-900">
      <div className="mx-auto max-w-[1280px] px-6 pt-9 pb-16 sm:px-10">
        <MigrationsManager />
      </div>
    </div>
  );
}
